import { gql } from '@apollo/client';

import { Course } from '../../types';
import { courseFragment } from '../fragments';

export interface ToggleCoursePeriodMutationVariables {
  courseId: string;
  status: 'open' | 'close';
}

export interface ToggleCoursePeriodMutationResult {
  course: Course;
}

export const toggleCoursePeriodMutation = gql`
  mutation ToggleCoursePeriod($courseId: String, $status: String!) {
    course(courseId: $courseId, status: $status, input: {})
      @rest(type: "Course", path: "courses/{args.courseId}/periods/{args.status}", method: "POST") {
      ...Course
    }
  }
  ${courseFragment}
`;
